import { BaseError } from '@sdk/errors/BaseError';

export class NetworkError<
  TData extends object | undefined = Record<string, unknown>,
> extends BaseError<TData> {
  constructor(message: string, { cause, data }: { cause?: unknown; data?: TData } = {}) {
    super(message, { cause, data });
  }
}

export interface IncompatibleNetworkErrorData {
  traderChainId: number;
  merchantChainId: number;
  activeChainId: number;
  expectedChainId: number;
  expectedChainName?: string;
}

export class IncompatibleNetworkError extends NetworkError<IncompatibleNetworkErrorData> {
  constructor(
    message: string,
    { cause, data }: { cause?: unknown; data?: IncompatibleNetworkErrorData },
  ) {
    super(message, { cause, data });
  }
}
